import React from 'react';
import { BaseComponent } from '../../../components/BaseComponent';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';

import { selectConfig, selectWorks } from '../../Api/selectors';
import { REQUEST_COMPANY } from '../constants';
import { createCompany } from '../actions';
import { selectNewCompany } from '../selectors';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../containers/App/Components/Button/Button';

const STATE = {
  isCancelWithoutSave: null,
};

/* eslint-disable react/prefer-stateless-function */
class CancelNotificationModalComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  render() {
    const { onYes, onNo } = this.props;

    return (
      <ModalComponent>
        <p>{this.lbl('cancel.save_without_changes_notification')}</p>
        <div className="d-flex gap-2">
          <ButtonComponent style={'ButtonSoftPrimary'} onClick={onNo}>
            {this.lbl('no')}
          </ButtonComponent>
          <ButtonComponent style={'ButtonSoftPrimary'} onClick={onYes}>
            {this.lbl('yes')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }
}

CancelNotificationModalComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_COMPANY]),
    values: selectNewCompany(),
    config: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    create(properties, options, callback) {
      dispatch(createCompany(properties, options, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CancelNotificationModal = compose(withConnect, withRouter)(CancelNotificationModalComp);
